import Api from '../Api';

import { url } from './config';
import { Airline } from './types';

class ExtendedApi extends Api<Airline> {}

const api = new ExtendedApi(url);

export default api;
